var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_30829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04245 9.86182L2.32715 18.8487C3.00816 22.4831 8.84971 25.1351 14.0001 25.1351C19.1505 25.1351 24.992 22.4831 25.673 18.8486L21.9577 9.86182H6.04245Z",
    fill: "#677293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21.4009C18.2298 21.4009 21.6587 17.972 21.6587 13.7422C21.6587 9.51241 18.2298 6.0835 14 6.0835C9.77022 6.0835 6.34131 9.51241 6.34131 13.7422C6.34131 17.972 9.77022 21.4009 14 21.4009Z",
    fill: "#FFD0C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9822 13.7422C8.9822 9.9627 11.72 6.82301 15.3205 6.19726C14.8914 6.12272 14.4503 6.0835 14 6.0835C9.77022 6.0835 6.34131 9.5124 6.34131 13.7422C6.34131 17.972 9.77022 21.4009 14 21.4009C14.4504 21.4009 14.8915 21.3617 15.3205 21.2872C11.72 20.6614 8.9822 17.5217 8.9822 13.7422Z",
    fill: "#F2B6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0.875C3.29126 0.875 1.64602 15.2143 2.32703 18.8487C3.15217 18.8487 3.88404 18.3197 4.14264 17.5361C5.0535 14.7759 8.61155 11.344 14 11.344C19.3884 11.344 22.9465 14.7758 23.8573 17.5361C24.1159 18.3197 24.8478 18.8487 25.6729 18.8487C26.3539 15.2143 24.7087 0.875 14 0.875Z",
    fill: "#B7BCCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79793 17.1333C10.6542 17.1333 11.3484 16.5805 11.3484 15.8985C11.3484 15.2166 10.6542 14.6638 9.79793 14.6638C8.94162 14.6638 8.24744 15.2166 8.24744 15.8985C8.24744 16.5805 8.94162 17.1333 9.79793 17.1333Z",
    fill: "#FFA1AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2022 17.1333C19.0585 17.1333 19.7527 16.5805 19.7527 15.8985C19.7527 15.2166 19.0585 14.6638 18.2022 14.6638C17.3459 14.6638 16.6517 15.2166 16.6517 15.8985C16.6517 16.5805 17.3459 17.1333 18.2022 17.1333Z",
    fill: "#FFA1AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8698 14.3064C14.7625 14.3064 14.6558 14.3511 14.5798 14.4383C14.4334 14.6063 14.2221 14.7026 14 14.7026C13.778 14.7026 13.5667 14.6063 13.4203 14.4383C13.2807 14.2782 13.0378 14.2616 12.8778 14.4011C12.7176 14.5406 12.701 14.7835 12.8405 14.9436C13.133 15.2792 13.5556 15.4717 14 15.4717C14.4444 15.4717 14.8671 15.2792 15.1595 14.9436C15.299 14.7835 15.2823 14.5406 15.1222 14.4011C15.0494 14.3375 14.9594 14.3064 14.8698 14.3064Z",
    fill: "#677293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76546 6.10952C8.76546 3.21858 11.109 0.875 14 0.875C3.29126 0.875 1.64602 15.2143 2.32703 18.8487C3.15217 18.8487 3.88409 18.3197 4.14264 17.5361C5.0535 14.7759 8.61155 11.344 14 11.344C11.109 11.344 8.76546 9.00045 8.76546 6.10952Z",
    fill: "#868EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9338 27.125H8.06608C7.53334 27.125 7.08396 26.7283 7.01787 26.1996L6.18849 19.5645C6.12937 19.0916 6.4981 18.674 6.97465 18.674H21.0253C21.5019 18.674 21.8706 19.0916 21.8115 19.5645L20.9821 26.1996C20.916 26.7283 20.4666 27.125 19.9338 27.125Z",
    fill: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8235 26.1996L9.99412 19.5645C9.93501 19.0916 10.3037 18.674 10.7803 18.674H6.97465C6.4981 18.674 6.12937 19.0916 6.18849 19.5645L7.01787 26.1996C7.08396 26.7283 7.53334 27.125 8.06608 27.125H11.8717C11.339 27.125 10.8896 26.7283 10.8235 26.1996Z",
    fill: "#E7E7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 24.484C14.8751 24.484 15.5845 23.7746 15.5845 22.8995C15.5845 22.0244 14.8751 21.3149 13.9999 21.3149C13.1248 21.3149 12.4154 22.0244 12.4154 22.8995C12.4154 23.7746 13.1248 24.484 13.9999 24.484Z",
    fill: "#E7E7EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_30829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 26.25,
    fill: "white",
    transform: "translate(0.875 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d7175976b5655fcc01e2da009bd2d9d9.svg";
export { ForwardRef as ReactComponent };